import { untrack } from "solid-js";
import { SetStoreFunction, Store } from "solid-js/store";

type StorePair<T> = [Store<T>, SetStoreFunction<T>];

namespace StorePair {
  export const safeSetter = <T,>([store, setStore]: StorePair<T>) =>
    ((...args: any[]) => {
      const value = args.pop();

      untrack(function createParents(current: any = store, i = 0) {
        if (i === args.length - 1) return;
        current = current[args[i]];

        if (current === undefined) {
          // @ts-expect-error
          setStore(...args.slice(0, i + 1), {});
        }

        createParents(current, i + 1);
      });

      // @ts-expect-error
      setStore(...args, value);
    }) as SetStoreFunction<T>;
}

export default StorePair;
